import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.scss';
import configureAppStore from './store';
import App from './App';
// import config from 'config';
// import * as Sentry from '@sentry/browser';
import * as serviceWorkerAsset from './serviceWorker';
import { initializeFirebase } from 'fcm/init';
import history from './utils/createHistory';

import { ConnectedRouter } from 'connected-react-router';
// Sentry.init({
//   dsn: config.sentryIoDsn,
// });
import { LinearProgress } from '@material-ui/core';
import './i18n';
// import { onServiceWorkerUpdate } from 'components/ServiceWorker';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={configureAppStore()}>
    <ConnectedRouter history={history}>
      <Suspense fallback={<LinearProgress />}>
        <App />
      </Suspense>
    </ConnectedRouter>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
initializeFirebase();
/**
 * TODO: not working in demo or prod for now
 */
// serviceWorkerAsset.register({
//   onUpdate: onServiceWorkerUpdate,
// });
serviceWorkerAsset.unregister();
